export enum VerifyRolesResult {
  Verified = "Verified",
  Updated = "Updated",
  Error = "Error",
}
